// extracted by mini-css-extract-plugin
export default {"root":"ValidationTextInput_root__g9p3q","errorMessage":"ValidationTextInput_errorMessage__RfksX"};